"use client";
import styled from "styled-components";
import {text, white} from "@/styles/globalStyleVars";
import MisionSingle from "@/components/common/MisionSingle";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";

function Mision({data}) {

    const mainData = data?.posts?.list
    const isMobile = useDeviceTypeTab()
    ;

    return (
        <StyleComponent className="mision_vision d-flex">


            {
                mainData && mainData?.length > 0 &&
                mainData?.map((e, index) => {
                    if(isMobile){
                        return(
                            <MisionSingle key={index} title={e?.data?.title} description={e?.data?.description} image={e?.images?.[0]?.full_path} dataSpeed={index === 0 ? '0' : index === 1 ? '0' : index === 2 ? '0' : '1.2'}/>
                        )
                    }else{
                        return(
                            <MisionSingle key={index} title={e?.data?.title} description={e?.data?.description} image={e?.images?.[0]?.full_path} dataSpeed={index === 0 ? '1.3' : index === 1 ? '1.1' : index === 2 ? '1.2' : '1.2'}/>
                        )
                    }

                })
            }
        </StyleComponent>
);
}
const StyleComponent = styled.section`
    background-color: ${white};
    position: relative;
    width: 100%;

    &:after{
        background: ${text};
        position: absolute;
        left: 0;
        right: 0;
        content: '';
        bottom: 0;
        height: 50%;
        z-index: 0;
    }
    .single-item-mission{
        width: 100%;
        position: relative;
        z-index: 1;
    }
    
    @media (max-width: 992px) {
        flex-direction: column;
        background: ${text};
        .serviceSingle{
            margin-bottom: 30px;
            &:last-child{
                margin-bottom: 0;
            }
        }
        
        .global-image{
            border-radius: 0;
        }
    }

`;
export default Mision